module.exports = __webpack_public_path__ + "img/dashiji-2011.8a0452fe.jpg";